
import { Component, Input, signal } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { ConnectServerService } from '../../../../services/connect-server.service';
import { PopupDialogService } from '../../../../services/popup-dialog.service';
import { CheckFormValidityService } from '../../../../services/check-form-validity.service';
import { ApiResponse } from '../../../../interfaces/api-response';

interface Relations {
  id: number;
  relation: string;
}

@Component({
  selector: 'app-relations',
  imports: [
    MatExpansionModule,
    ReactiveFormsModule
],
  templateUrl: './relations.component.html',
  styleUrl: './relations.component.scss'
})
export class RelationsComponent {
  readonly panelOpenState = signal(false);

  @Input() idarticle: number = 0;
  saved: boolean = false;
  submitted: boolean = false;

  relationsForm: FormGroup;

  constructor(private fb: FormBuilder, private connectServerService: ConnectServerService,
    private popupDialogService: PopupDialogService,
    private checkFormValidityService: CheckFormValidityService) {
    this.relationsForm = this.fb.group({
      relations: this.fb.array([this.createRelations()]),

    });
  }
  get relations(): FormArray {
    return this.relationsForm.get('relations') as FormArray;
  }
  createRelations(): FormGroup {
    return this.fb.group({
      id: [0],
      relation: [null, Validators.maxLength(25)]
    })
  }
  createRelationsValues(content: Relations): FormGroup {
    return this.fb.group({
      id: [content.id],
      relation: [content.relation, Validators.maxLength(25)]
    })
  }
  addRelations() {
    this.relations.push(this.createRelations());
  }

  addRelationsValues(relations: Relations) {
    this.relations.push(this.createRelationsValues(relations));
  }
  removeRelations(index: number) {
    if (this.relations.length > 1) {
      this.relations.removeAt(index);
    }
  }
  ngOnInit(): void {
   this.getRelationsInfo();
  }
  private getRelationsInfo() {
    this.connectServerService.getRequest('relationsInfo', { idarticle: this.idarticle })
      .subscribe((val: ApiResponse<{ relationsForm: any }>) => {
        this.relations.clear();

        if (val.data.relationsForm.relations.length == 0) {
          this.addRelations();
        }
        else {
          val.data.relationsForm.relations.forEach((element: Relations) => {
            this.addRelationsValues(element);
          });
        }

        this.saved = this.checkFormValidityService.areAllRequiredFieldsFilled(this.relationsForm);
        if(this.saved) {
          this.panelOpenState.set(false);
        }
        else {
          this.panelOpenState.set(true);
        }
      })
  }

  private setRelationsInfo() {
    const formValues = this.relationsForm.getRawValue()
    this.connectServerService.postRequest<ApiResponse<null>>('updateRelationsInfo', {
      relations: formValues.relations,
      idarticle: this.idarticle,
    }).subscribe(
      (val: ApiResponse<null>) => {
        this.popupDialogService.popupDialog(val);
        this.getRelationsInfo();
      }
    )
  }

  save() {
    this.submitted = true;
    if(this.relationsForm.valid) {
      this.setRelationsInfo();
    }
  }
}
